export enum AdminDecisionEnum {
    Approve = 0,
    Amends = 1,
    Reject = 2,
}
